// extracted by mini-css-extract-plugin
module.exports = {"introCopy":"intro-copy-module--introCopy--36EF1","headline":"intro-copy-module--headline--1Mv_w"};